<app-report-self-inspection-wrapper
  [data]="wrapperData"
  [isLoading$]="isLoading$"
>
  @for (input of inputValues; track $index; let index = $index) {
    @if (index <= data.requiredFieldsAmount - 1) {
      <!-- icon logic for later index === 0 ? data.icon : undefined-->
      <gc-input-field
        class="required-input"
        [label]="data.label + ' ' + (index + 1)"
        [placeholder]="data.placeHolder"
        [value]="input"
        [icon]="undefined"
        (changed)="handleOnChangeInput($event, index)"
        (enterPressed)="handleOnClickSave()"
        (iconClicked)="clickIcon.emit()"
      />
    } @else {
      <div class="optional-input-container">
        <gc-input-field
          class="optional-input"
          [label]="data.label + ' ' + (index + 1)"
          [placeholder]="data.placeHolder"
          [value]="input"
          (changed)="handleOnChangeInput($event, index)"
          (enterPressed)="handleOnClickSave()"
        />
        <gc-button
          class="delete-button"
          variant="plain"
          icon="trash"
          iconSize="medium"
          (clicked)="handleOnDelete(index)"
        />
      </div>
    }
  }
  @if (showAddMoreButton()) {
    <gc-button
      class="add-more-button"
      variant="utility"
      size="small"
      iconPosition="left"
      icon="plus"
      (clicked)="addInputField()"
      >{{ 'reportInput.addMore' | translate }}</gc-button
    >
    @if (displayButtons) {
      <hr />
    }
  }
  @if (displayButtons) {
    <app-save-buttons
      (save)="handleOnClickSave()"
      (cancel)="handleOnClickCancel()"
    />
  }
</app-report-self-inspection-wrapper>
